import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IFormActions } from 'src/app/interfaces/IForm';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-form-button',
  imports: [CommonModule, MaterialModule, TranslateModule, TablerIconsModule],
  templateUrl: './form-button.component.html',
  styleUrl: './form-button.component.scss',
  host: { '[class.login-appearance]': "appearance === 'login'" }
})
export class FormButtonComponent {
  @Input() btnConfig: IFormActions;
  @Input() spinLoader: boolean;
  @Input() appearance: 'default' | 'login' = 'default';

  get ButtonText(): string {
    if (typeof this.btnConfig.text === 'function') {
      return this.btnConfig.text();
    }
    return this.btnConfig.text;
  }
}
